import { BaseRestService } from "./BaseRestService";
import { API_URL_V2 } from "./constants/api";

export const restServiceV2 = new BaseRestService(API_URL_V2);
